// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2Wfxp","content":"Consent_content__18mm4","footer":"Consent_footer__2ch16"};